// src/components/ShopScreen.ts — Tienda Liora Fase 5
import { store } from '../app/state.js';
import { saveLocal } from '../app/storage.js';
import { SHOP_CATALOG, getItem } from '../data/items.js';
import { notify } from '../systems/notificationSystem.js';

export function createShopScreen(onClose:()=>void): HTMLElement {
  const el = document.createElement('div');
  el.style.cssText='position:absolute;inset:0;background:rgba(7,11,26,.88);backdrop-filter:blur(10px);display:grid;place-items:center;padding:1rem;z-index:19;overflow:auto;';
  const render = () => {
    const s = store.get();
    el.innerHTML = `
      <div style="width:min(760px,98vw);max-height:92vh;overflow:auto;background:linear-gradient(180deg, rgba(18,26,51,.98), rgba(14,20,42,.99));border:1px solid rgba(255,255,255,.12);border-radius:18px;box-shadow:0 20px 60px rgba(0,0,0,.6);padding:1rem">
        <div style="display:flex;justify-content:space-between;align-items:center;gap:.75rem;flex-wrap:wrap">
          <div>
            <div class="kicker">Bazar de Liora</div>
            <div style="font-family:var(--font-display);font-weight:800;font-size:1.25rem">Tienda</div>
            <div style="font-size:.78rem;color:var(--muted)">Bienvenido, ${s.profile.name}. ¿Qué necesitas para tu viaje?</div>
          </div>
          <div style="display:flex;gap:.5rem;align-items:center">
            <span class="chip" style="background:rgba(255,207,107,.15)">💰 ${s.currency} Aurel</span>
            <button data-close type="button" class="btn btn--ghost" style="width:auto;padding:.5rem .75rem">✕ Cerrar</button>
          </div>
        </div>

        <div style="margin-top:.8rem;display:grid;gap:.5rem">
          ${SHOP_CATALOG.map(entry=>{
            const def = getItem(entry.id)!;
            const owned = s.inventory.find(i=> i.id===entry.id)?.qty ?? 0;
            const canBuy = s.currency >= entry.price;
            return `<div style="display:flex;gap:.75rem;align-items:center;padding:.6rem;border-radius:12px;background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.06)">
              <div style="width:44px;height:44px;border-radius:10px;background:rgba(255,255,255,.04);display:grid;place-items:center;font-size:20px;border:1px solid rgba(255,255,255,.08)">${def.icon ?? '•'}</div>
              <div style="flex:1">
                <div style="font-weight:800">${def.name} <span style="font-family:var(--font-mono);font-size:.68rem;color:var(--muted)">×${owned} en mochila</span></div>
                <div style="font-size:.78rem;color:var(--muted)">${def.description}</div>
                <div style="display:flex;gap:.3rem;margin-top:.2rem"><span class="chip" style="font-size:.62rem">${def.category}</span><span class="chip" style="font-size:.62rem">${def.price} Aurel</span></div>
              </div>
              <button data-buy="${entry.id}" type="button" class="btn ${canBuy?'btn--primary':'btn--subtle'}" style="width:auto;padding:.5rem .75rem;${!canBuy?'opacity:.5;pointer-events:none':''}">Comprar</button>
            </div>`;
          }).join('')}
        </div>

        <div style="margin-top:.8rem;display:flex;gap:.4rem;flex-wrap:wrap">
          <span class="chip">Vende con inventario → Mochila → Vender</span>
          <span class="chip">Objetos clave no vendibles</span>
        </div>
      </div>
    `;
    el.querySelector<HTMLButtonElement>('[data-close]')!.addEventListener('click', onClose);
    el.querySelectorAll<HTMLButtonElement>('[data-buy]').forEach(btn=>{
      btn.addEventListener('click',()=>{
        const id = btn.dataset.buy!;
        const entry = SHOP_CATALOG.find(e=> e.id===id)!;
        const st = store.get();
        if(st.currency < entry.price){ notify('No tienes suficientes Aurel', 'warning'); return; }
        const def = getItem(id)!;
        // comprobar capacidad? siempre se puede
        st.currency -= entry.price;
        st.trainer.aureos = st.currency;
        const inv = st.inventory.find(i=> i.id===id);
        if(inv) inv.qty +=1; else st.inventory.push({ id, qty:1 });
        // mission progress: conseguir_item
        import('../systems/missionSystem.js').then(m=> {
          m.updateObjective(st, 'conseguir_item', id, 1);
          m.refreshMissions(st);
        });
        store.setState(st); saveLocal(st);
        notify(`Comprado ${def.name} por ${entry.price} Aurel`, 'success');
        render();
      });
    });
  };
  render();
  return el;
}
